'use strict';

module.exports = function FileChangesModel(pageController, collaborationModel, unsavedChangesModel, goldFileChangesModel) {
	let currentChangesModel = false;
	const setCurrentChangesModel = (newChangesModel, fileInfo) => {
		if (currentChangesModel === newChangesModel) {
			return;
		}

		if (currentChangesModel?.halt) {
			currentChangesModel.halt();
		}

		currentChangesModel = newChangesModel;

		if (currentChangesModel?.start) {
			currentChangesModel.start(fileInfo);
		}
	};
	pageController.addEventListener('fileInfo', (fileInfo) => {
		if (fileInfo && fileInfo.allowedActions && fileInfo.allowedActions.uploadChanges) {
			setCurrentChangesModel(goldFileChangesModel, fileInfo);
		} else {
			setCurrentChangesModel(unsavedChangesModel, fileInfo);
		}
	});
	pageController.addEventListener('saveFileSuccess', () => {
		if (currentChangesModel?.notifyFileSaved) {
			currentChangesModel.notifyFileSaved();
		}
	});
	pageController.addEventListener('savingFile', () => {
		if (currentChangesModel?.notifyFileSaving) {
			currentChangesModel.notifyFileSaving();
		}
	});
	collaborationModel.addEventListener('localContentEvent', (evt) => {
		if (currentChangesModel?.localContentEvent) {
			currentChangesModel.localContentEvent(evt);
		}
	});
};
